export const moduleSlug = "BRANCHES";

export const branchesFields = {
    name: "name",
    tier1OrgsCount: "tier1OrgsCount",
    tier1OrgsRank: "tier1OrgsRank"
};

export default { moduleSlug };